import React, { Component } from "react";
import { Grid, Row } from "react-bootstrap";

class Dashboard extends Component {
  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }
  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
              <h3>Welcome to the Wrapify Official Installer Dashboard!</h3>
              <p>The Wrapify dashboard provides you with the ability to see your current and past appointments, create
                 install and uninstall appointments and download the documentation you need to complete jobs and get
                 paid for your work.</p>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.jsx